export interface HomeCategory {
  id?: number; // Optional to handle optional/new entity payloads
  name?: string;
  image: string;
  categoryId: string;
  section?: string;
}

export interface Deal {
  id: number;
  discount: number;
  category: HomeCategory;
}

export enum BannerType {
  SLIDE = 'SLIDE',
  LEFT_AD = 'LEFT_AD',
  RIGHT_AD = 'RIGHT_AD',
}

export interface HomeBanner {
  id?: number;
  title?: string;
  subtitle?: string;
  imageUrl: string;
  targetUrl?: string;
  promoCode?: string;
  bannerType: BannerType;
  active?: boolean;
  createdAt?: string;
}